<template>
  <div class="date-dropdown">
    <PillDropdown
      name="Date"
      :options="dateOptions"
    >
    </PillDropdown>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import PillDropdown from './PillDropdown.vue';

const dateOptions = computed(() => {
  return ['Today', 'Last 7 days', 'Last 30 days', 'This Year', 'Last Year', 'Custom Date range'].map((type) => {
    return { name: type, checked: false };
  });
});
</script>
